import { Component, forwardRef, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';

import { PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import { Subscription } from 'rxjs';
import { ContactFormValues } from 'src/app/model';
import { SubmitButtonClickService } from 'src/app/services';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ContactFormComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ContactFormComponent),
      multi: true
    }
  ]
})
export class ContactFormComponent implements ControlValueAccessor, OnDestroy, OnInit, OnChanges {
  @Input() pageType: any;
  @Input() pocName: any;
  form: FormGroup;
  separateDialCode = false;
  SearchCountryField = SearchCountryField;
  PhoneNumberFormat = PhoneNumberFormat;
  submitted: boolean = false;

  private _subscriptions: Subscription[] = [];
  private _valueChangesSubscription: Subscription;
  private _getSubmitButtonClickSubscription: Subscription;
  private _getSubmitButtonSuccessSubscription: Subscription;


  constructor(
    private _fb: FormBuilder,
    private _submitButtonClick: SubmitButtonClickService,
    private _submitButtonSuccess: SubmitButtonClickService
  ) {
    this.form = this._fb.group({
      country: [this.pageType === 'users' ? '' : 'IN'],
      number: [''],
      email: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
    });

    this._subscriptions.push(
      // any time the inner form changes update the parent of any change
      this._valueChangesSubscription = this.form.valueChanges.subscribe(value => {
        this.onChange(value);
        this.onTouched();
      })
    );
    this._getSubmitButtonClickSubscription = this._submitButtonClick.getSubmitButtonClick().subscribe((res: any) => {
      this.submitted = true;
    });
    this._getSubmitButtonSuccessSubscription = this._submitButtonSuccess.getSubmitButtonSuccess().subscribe((res: any) => {
      this.submitted = false;
    })
  }
  ngOnChanges() {
    if (this.pageType === 'plantPoc') {
      if (this.pocName) {
        this.form.controls['email'].setValidators([Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]);
        this.form.controls['email'].updateValueAndValidity();
      } else {
        this.form.controls['email'].removeValidators(Validators.required);
        this.form.controls['email'].updateValueAndValidity();
      }
    }
  }
  ngOnInit(): void {
    if (this.pageType === 'signup') {
      this.form.controls['number'].clearValidators();
      this.form.controls['number'].updateValueAndValidity();
    }
    setTimeout(() => {
      (this.pageType !== 'users' && this.pageType !== 'plantPoc'
        && this.pageType !== 'plant') ? this.form.controls['country'].patchValue('IN') : null;
    }, 1);
  }


  get value(): ContactFormValues {
    return this.form.value;
  }

  get contactFormValues() {
    return this.form.controls;
  }

  set value(value: ContactFormValues) {
    this.form.setValue(value);
    this.onChange(value);
    this.onTouched();
  }

  ngOnDestroy() {
    this._subscriptions.forEach(s => s.unsubscribe());
    this._valueChangesSubscription?.unsubscribe();
    this._getSubmitButtonClickSubscription?.unsubscribe();
    this._getSubmitButtonSuccessSubscription?.unsubscribe();

  }

  onChange: any = () => { };
  onTouched: any = () => { };

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  writeValue(value: ContactFormValues | null) {
    if (value) {
      this.value = value;
    }

    if (value === null) {
      this.form.reset();
    }
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  // communicate the inner form validation to the parent form
  validate(_: FormControl) {
    return this.form.valid ? null : { contact: { valid: false } };
  }

}
